import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast, { Toaster } from "react-hot-toast";
import * as services from "./../services/saleng";
import { jwtDecode } from "jwt-decode";
import logo from "../images/saleng shop.png";

// Update schema to use username instead of email
const schema = yup.object().shape({
  username: yup.string().required("Please enter username"),
  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password must not exceed 20 characters")
    .notOneOf(
      [yup.ref("username"), null],
      "Password must not be the same as your username"
    )
    .required("Please enter password"),
});

export default function Login() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const onSubmitNew = async (data) => {
    const payload = {
      username: data.username,
      password: data.password,
    };

    try {
      // Attempt login
      const greenResponse = await services.loginShop(payload);
      const greenData = greenResponse.data;

      if (!greenData.success) {
        // Handle login failure
        toast.error(greenData.error || "Something went wrong");
        return;
      }

      console.log("Login successfully (Shop):", greenData);

      // Extract and store the access token
      const { accessToken } = greenData.data;
      localStorage.setItem("accessToken", JSON.stringify(accessToken));

      if (accessToken) {
        var decoded = jwtDecode(accessToken);
        var shopId = decoded.id;
      }
      const shopResponse = await services.getShop(shopId);
      const shopData = shopResponse.data.data;
      if (shopData) {
        console.log("Shop data retrieved successfully.");
        navigate("/");
        return;
      }
      navigate("/");
    } catch (error) {
      // Handle errors (both login and shop-related)
      toast.error(error?.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-blue-50">
      <Toaster />
      <form
        onSubmit={handleSubmit(onSubmitNew)}
        className="w-full max-w-md p-8 space-y-4 bg-white shadow-md rounded-2xl"
      >
        <div>
          <div className="flex items-center justify-center mb-6">
            <img
              src={logo}
              alt="logo"
              style={{ width: "250px", height: "100px", marginRight: "12px" }}
            />
            <h2 className="text-2xl font-bold text-blue-900">POS</h2>
          </div>
          <h2 className="text-2xl font-bold mb-7 text-center mt-3 text-blue-900">
            เข้าสู่ระบบ
          </h2>

          <div className="mt-5">
            <label htmlFor="username" className="text-sm font-semibold mb-1">
              ชื่อผู้ใช้
            </label>
            <input
              className="w-full px-3 py-2 border rounded"
              type="text"
              placeholder="ชื่อผู้ใช้"
              {...register("username")}
            />
            {errors?.username && (
              <p className="text-red-500 text-xs mt-1">
                {errors.username?.message}
              </p>
            )}
          </div>
          <div className="mt-5">
            <label htmlFor="password" className="text-sm font-semibold mb-1">
              รหัสผ่าน
            </label>
            <input
              className="w-full px-3 py-2 border rounded"
              type="password"
              placeholder="รหัสผ่าน"
              {...register("password")}
            />
            {errors?.password && (
              <p className="text-red-500 text-xs mt-1">
                {errors.password?.message}
              </p>
            )}
          </div>

          <div className="mt-8">
            <button
              className="w-full px-3 py-2 text-white bg-blue-950 hover:bg-blue-900 rounded-md"
              type="submit"
            >
              <span className="text-sm">ลงชื่อเข้าใช้</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
